import "./OpticksExpanderChevronIcon.css";
import classNames from "classnames";
import OpticksButton, {
  type OpticksButtonSize,
} from "../../OpticksButton/OpticksButton";
import ChevronDownIcon from "../../OpticksIcons/ChevronDownIcon";

interface Props {
  expanded: boolean;
  label?: string;
  onClick: () => void;
  variation?: string;
  size?: OpticksButtonSize;
}

const OpticksExpanderChevronIcon = ({
  expanded,
  label,
  onClick,
  variation = "ghost",
  size = "s",
}: Props) => (
  <div
    className={classNames("opticks-expander-chevron-icon", {
      expanded: expanded,
    })}
  >
    <OpticksButton
      label={label}
      iconTrailing={<ChevronDownIcon />}
      onClick={onClick}
      variation={variation}
      size={size}
    />
  </div>
);

export default OpticksExpanderChevronIcon;
